import React from 'react';

export function HintTooltip({ show, hintText }) {
    return (
        <div className={`hint-tooltip ${show ? 'show' : ''}`}>
            <div className="hint-text">{hintText}</div>
        </div>
    );
}
